// extracted by mini-css-extract-plugin
export var stickyContainer = "registrationBlock-module--stickyContainer--3bca6";
export var stickyContent = "registrationBlock-module--stickyContent--06bc8";